import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { CoreUiModule } from "@obg/ngx.ui.core";

import { ProgressBarComponent } from "./progress-bar.component";

const DIRECTIVES: any[] = [ProgressBarComponent];

@NgModule({
	imports: [CoreUiModule, CoreContentModule, CommonModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ProgressBarModule {}
